import "./GiftItem.less";
import {
    GiftType,
    PlayerColor,
    SelectableBuildingDataSet,
    SelectableColorCss,
    SelectableFighterDataSet,
    SkinType
} from "@game/coregame/settings";
import {SVG} from "@game/ui/images";
import {useInjection} from "@dp-instant/ui";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import cn from "classnames";
import {BuildingItem} from "@game/ui/components/Shop/BuildingItem/BuildingItem";
import {FighterItem} from "@game/ui/components/Shop/FighterItem/FighterItem";
import {Images} from "@game/ui/images";

const RewardItem = ({type, id, value}: GiftType) => {
    const model = useInjection<GameModel>(TypesGame.model);
    const colorSet = model.cookie.selectedColorSet;
    const playerColor: PlayerColor | undefined = colorSet?.data;
    const shopItemColorClassName =
        SelectableColorCss.find(item => item.id === colorSet?.id)?.className || "";
    switch (type) {
        case SkinType.BUILDING:
            return (
                <BuildingItem
                    textureUrl={
                        SelectableBuildingDataSet.find(item => item.id === id)?.ui_textureUrl
                    }
                    className={shopItemColorClassName}
                    playerColor={playerColor}
                />
            );
        case SkinType.FIGHTER:
            return (
                <FighterItem
                    textureUrl={
                        SelectableFighterDataSet.find(item => item.id === id)?.ui_textureUrl
                    }
                    className={shopItemColorClassName}
                    playerColor={playerColor}
                />
            );
        case "money":
            return (
                <div className={cn("gift-coin")}>
                    <SVG.COINS />
                    <div className={cn("gift-value")}>{value}</div>
                </div>
            );
    }
};
export const GiftItem = ({reward, value}: {reward?: GiftType | null; value?: number}) => {
    return (
        <span className={cn("shop-item", "gift-item")}>
            {reward ? (
                <RewardItem id={reward.id} type={reward.type} value={value} />
            ) : (
                <Images.Gift />
            )}
        </span>
    );
};
